import type { UseQueryResult } from '@tanstack/react-query';
import { useTestRubricItems } from 'services/assist-api/entities/test-rubric-item/hooks';
import type { TestRubricItemWithOptions } from 'services/assist-api/entities/test-rubric-item/types';

/**
 * Fetches the rubric items that are needed to display a Mark Response page.
 */
export default function useRubricItemsForMarking(
  rubricId: number | undefined
): UseQueryResult<RequestResponse<TestRubricItemWithOptions[]>, RequestError> {
  /**
   * Currently we are only fetching the rubric items for the first rubric. This
   * is because for CIPS writing (currently the only test that will use the
   * Mark Response screen), there is expected to only ever be only rubric per test.
   * If we need to mark tests with multiple rubrics, this logic will need to be
   * expanded.
   */
  return useTestRubricItems<TestRubricItemWithOptions>(
    {
      filters: { testRubrics: rubricId },
      groups: [
        'testrubricitem-displayName',
        'testrubricitem-testrubricitemoptions',
        'testrubricitemoption-details'
      ],
      include: 'testRubricItemOptions'
    },
    { enabled: !!rubricId }
  );
}
